import { Button, Intent } from '@blueprintjs/core';
import PropTypes from 'prop-types';
import { PureComponent } from 'react';

class RemoveButton extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    data: PropTypes.object,
    disabled: PropTypes.bool,
    onRemove: PropTypes.func,
  };

  onRemove = () => {
    const { data } = this.props;
    this.props.onRemove(data.id);
  };

  render() {
    const { className, disabled } = this.props;

    return (
      <Button
        className={className}
        minimal
        disabled={disabled}
        intent={Intent.DANGER}
        text="Remove"
        icon="trash"
        onClick={this.onRemove}
        data-test="remove-item-button"
      />
    );
  }
}

export default RemoveButton;
